import { lazy, Suspense } from "react";
import Loader from '../customs/spinner/spinner';

const Main = lazy(() => import('../components/loadList/postLoad/postLoad'));

const PostLoad = () => {
    return (
        <Suspense fallback={<Loader color="#FF6136"/>}>
            <Main/>
        </Suspense>
    )
}

export default PostLoad;